<template>
    <b-panel class="merge-duplicates-ctn" :collapsible="true" :open="false">
      <template #header>
        <strong>Find and merge duplicates</strong>
      </template>
        <div class="panel-tabs">
            <a :class="{ 'is-active': selectedTab === 'contacts' }" @click="selectedTab = 'contacts'">Contacts</a>
            <a :class="{ 'is-active': selectedTab === 'companies' }" @click="selectedTab = 'companies'">Companies</a>
            <a :class="{ 'is-active': selectedTab === 'similar-companies' }" @click="selectedTab = 'similar-companies'">Similar Companies</a>
        </div>
        <div class="content full-width">
            <merge-contacts v-if="selectedTab === 'contacts'"/>
            <merge-companies v-if="selectedTab === 'companies'"/>
            <MergeSimilarCompanies v-if="selectedTab === 'similar-companies'"/>
        </div>
    </b-panel>
</template>

<script>
    import MergeCompanies from "./MergeCompanies.vue"
    import MergeContacts from "./MergeContacts.vue"
    import MergeSimilarCompanies from "./MergeSimilarCompanies.vue";

    export default {
        components: {
          MergeSimilarCompanies,
            MergeCompanies,
            MergeContacts,
         },

        data () {
            return {
               selectedTab: 'contacts',
            }
        },
        watch: {
        },
        mounted() {
        },
        computed: {
        },

        methods: {
        }
    }
</script>
<style>
.merge-duplicates-ctn .panel-content {
  flex-direction: column;
  padding: 0;
}

.panel-tabs {
  width: 100%;
}

.content {
  padding: 12px;
}

</style>